import script from "./ListSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListSwitcher.vue?vue&type=script&setup=true&lang=ts"

import "./ListSwitcher.vue?vue&type=style&index=0&id=c739796e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c739796e"]])

export default __exports__